import type { DistributionCenterResponse } from 'api/__GENERATED';
import { MISSING_VALUE } from 'config/app';

// Maps a single DistributionCenter DTO from the generated API client onto the
// normalized `Data.DistributionCenter` shape. The DTO still leaves `branchId`,
// `areaIds`, and `zoneIds` nullable — coalesce with sensible defaults so the
// domain interface (all non-null) stays honest.
function toDistributionCenter(dto: DistributionCenterResponse) {
  const { id, name, description, branchId, areaIds, zoneIds } = dto;

  const distributionCenter: Data.DistributionCenter = {
    id,
    name,
    description: description ?? '',
    branchId: branchId ?? MISSING_VALUE,
    areaIds: areaIds ?? [],
    zoneIds: zoneIds ?? [],
  };

  return distributionCenter;
}

export { toDistributionCenter };
